"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TrafficLayer = undefined;

var _defineProperty2 = require("babel-runtime/helpers/defineProperty");

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _MapChildHelper = require("../utils/MapChildHelper");

var _constants = require("../constants");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @url https://developers.google.com/maps/documentation/javascript/3.exp/reference#TrafficLayer
 */
/* global google */
var TrafficLayer = exports.TrafficLayer = function (_React$PureComponent) {
  (0, _inherits3.default)(TrafficLayer, _React$PureComponent);

  /*
   * @url https://developers.google.com/maps/documentation/javascript/3.exp/reference#TrafficLayer
   */
  function TrafficLayer(props, context) {
    (0, _classCallCheck3.default)(this, TrafficLayer);

    var _this = (0, _possibleConstructorReturn3.default)(this, (TrafficLayer.__proto__ || (0, _getPrototypeOf2.default)(TrafficLayer)).call(this, props, context));

    var trafficLayer = new google.maps.TrafficLayer();
    (0, _MapChildHelper.construct)(TrafficLayer.propTypes, updaterMap, _this.props, trafficLayer);
    trafficLayer.setMap(_this.context[_constants.MAP]);
    _this.state = (0, _defineProperty3.default)({}, _constants.TRAFFIC_LAYER, trafficLayer);
    return _this;
  }

  (0, _createClass3.default)(TrafficLayer, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      (0, _MapChildHelper.componentDidMount)(this, this.state[_constants.TRAFFIC_LAYER], eventMap);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      (0, _MapChildHelper.componentDidUpdate)(this, this.state[_constants.TRAFFIC_LAYER], eventMap, updaterMap, prevProps);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      (0, _MapChildHelper.componentWillUnmount)(this);
      var trafficLayer = this.state[_constants.TRAFFIC_LAYER];
      if (trafficLayer) {
        trafficLayer.setMap(null);
      }
    }
  }, {
    key: "render",
    value: function render() {
      return false;
    }
  }]);
  return TrafficLayer;
}(_react2.default.PureComponent);

TrafficLayer.propTypes = {
  /**
   * @type TrafficLayerOptions
   */
  defaultOptions: _propTypes2.default.any,

  /**
   * @type TrafficLayerOptions
   */
  options: _propTypes2.default.any
};
TrafficLayer.contextTypes = (0, _defineProperty3.default)({}, _constants.MAP, _propTypes2.default.object);
exports.default = TrafficLayer;


var eventMap = {};

var updaterMap = {
  options: function options(instance, _options) {
    instance.setOptions(_options);
  }
};


//////////////////
// WEBPACK FOOTER
// ../player-react-google-maps/lib/components/TrafficLayer.js
// module id = 886
// module chunks = 0